import StandardError from '../../StandardError'

export default class InvalidCodeError extends StandardError {
  constructor() {
    super('The coupon code you entered is invalid')
  }
}
